export default __webpack_public_path__ + "static/media/tagsWelcomes.14ac7ac8.svg";